export type TwoPanelLayout = [number, number];

const isFiniteNonNegative = (value: number) =>
  Number.isFinite(value) && value >= 0;

export const normalizeTwoPanelLayout = (
  layout: number[],
): TwoPanelLayout | null => {
  if (layout.length !== 2) return null;
  const first = layout[0];
  const second = layout[1];
  if (first === undefined || second === undefined) return null;
  if (!isFiniteNonNegative(first) || !isFiniteNonNegative(second)) {
    return null;
  }
  const total = first + second;
  if (total <= 0) return null;
  return [(first / total) * 100, (second / total) * 100];
};
